module.exports = __webpack_public_path__ + "img/49800.dc993332.jpg";